import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class ProductStateService {
  productLineHasChanges$ = new BehaviorSubject(false);
  resetChanges$ = new Subject<void>();
}
